<template>
  <div
    class="wrapper"
    v-if="minZoom"
  >

<div class="title">
      {{ $t("filters") }}:
    </div>
    <div class="filters">
      <MapFilter
        name="five_days"
        v-on:status="statusChange('fiveday', $event)"
      />
      <MapFilter
        name="distance"
        v-on:status="statusChange('distance', $event)"
      />
      <div
        class="slider-wrapper"
        v-if="slider"
      >
        <vue-slider
          v-model="distance"
          :interval="interval"
          :max="maxDistance"
          :min="minDistance"
        />
      </div>
    </div>

  </div>
</template>
<script>
import MapFilter from "./MapFilter";
import VueSlider from "vue-slider-component";
import "vue-slider-component/theme/default.css";
export default {
  components: {
    MapFilter,
    VueSlider
  },
  props: {
    rawmax: {
      required: true,
      type: Number
    },
    slider: {
      required: true,
      type: Boolean
    }
  },
  computed: {
    distance: {
      get: function() {
        if (this.lastDistance < this.maxDistance) {
          return this.lastDistance;
        } else return this.maxDistance / 2;
      },
      set: function(newValue) {
        this.$emit("distance", newValue);
        this.lastDistance = newValue;
        return newValue;
      }
    },
    minDistance() {
      if (this.rawmax >= 10) {
        return 1;
      } else if (this.rawmax > 5) {
        return 0.5;
      } else if (this.rawmax > 1) {
        return 0.2;
      } else {
        return 0.1;
      }
    },
    minZoom() {
      return this.rawmax > 0.1;
    },
    maxDistance() {
      if (this.rawmax >= 10) {
        return 10;
      } else if (this.rawmax > 5) {
        return Math.floor(this.rawmax);
      } else if (this.rawmax > 1) {
        return Math.round(this.rawmax * 10) / 10;
      } else {
        return Math.round(this.rawmax * 100) / 100;
      }
    },
    interval() {
      if (this.rawmax >= 10) {
        return 1;
      } else if (this.rawmax > 5) {
        return 0.5;
      } else if (this.rawmax > 1) {
        return 0.1;
      } else {
        return 0.01;
      }
    }
  },
  watch: {
    rawmax: function(val) {
      if (this.distance > val) {
        this.distance = Math.round(val / 2);
      }
    }
  },
  methods: {
    statusChange(buttonName, newStatus) {
      let output = {};
      output[buttonName] = newStatus;
      this.$emit("status", output);
    }
  }
};
</script>

<style scoped lang="scss">
.wrapper {
  display: block;

  .filters {
    display: block;
  }

  .title {
    color: $hku-gray-2;
    text-shadow: 1px 1px 5px rgba(0, 0, 0, 0.05);
    text-transform: uppercase;
    font-size: 15px;
    font-weight: 700;
    letter-spacing: 0.02em;
    margin-bottom: 5px;
  }
}

.slider-wrapper {
  display: block;
  padding-right: 10px;
  margin: 30px 16px;
  @media screen and (max-width: $breakpoint-tablet) {
    margin-bottom: 20px;
    margin-top: 20px;
  }
}
</style>
